import React from 'react';
import Snackbar from '.';

class SnackbarNotification extends React.Component {
  state = {
    message: null,
  };

  componentDidMount() {
    window.addEventListener(
      'SnackbarMessage',
      event => {
        this.setState({ message: event.value });
        if (event.auto_close_time !== 0) {
          setTimeout(this.close.bind(this), event.auto_close_time || 6000);
        }
      },
      false
    );
  }

  close() {
    this.setState({ message: null });
  }

  render() {
    if (this.state.message) {
      return (
        <Snackbar message={this.state.message} open={true}>
          <button className="btn btn-link" onClick={this.close.bind(this)}>
            OK
          </button>
        </Snackbar>
      );
    }

    return null;
  }
}

export default SnackbarNotification;
